/**
 * File: common.js.
 *
 * Import and initialize functions that are common to all pages
 */

import contactForm from "../modules/contactForm";
import newsletterForm from "../modules/newsletterForm";
import locationDisplay from "../modules/locationDisplay";
import locationOverviewMap from "../modules/locationOverviewMap";
import testimonials from "../modules/testimonials";
import twoRowCarousel from "../modules/twoRowCarousel";
import mobileNav from "../modules/mobileNav";
import hideSection from "../modules/hideSection";
import skipToMain from "../modules/skipToMain";
import nav from "../modules/nav";

export default {
  init() {
    this.render();
  },
  render() {
    twoRowCarousel.init();
    locationOverviewMap.init();
    testimonials.init();
    contactForm.init();
    newsletterForm.init();
    locationDisplay.init();
    mobileNav.init();
    hideSection.init();
    skipToMain.init();
    nav.init(); 
  },
  finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
